import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { fileTypes } from '@app/media/media.service';

@Injectable({
	providedIn: 'root'
})
@Pipe({name: 'mimeType', standalone: false})
export class MimeTypePipe implements PipeTransform {

	constructor() {}

	transform(mimetype?: string, asCode: boolean = false): string {
		if (typeof mimetype == 'undefined' || mimetype == null) {
			return '';
		}
		let foundType: any;
		for (let type in fileTypes) {
			const found: any = fileTypes[type].mimetypes.find((oneMimeType: 'string') => {
				return mimetype.match(oneMimeType);
			});
			if (found) {
				foundType = fileTypes[type];
				break;
			}
		}

		if (foundType) {
			return (asCode)? foundType.code : foundType.label;
		}
		return (asCode)? 'autre' : 'Autre';
	}
}

